import BaseReducer from 'utilities/BaseReducer';
import IRecipientState from './models/IRecipientState';
import RecipientAction from './RecipientAction';
import PersonResponse from './models/PersonResponse';
import IAction from 'models/IAction';

export default class RecipientReducer extends BaseReducer<IRecipientState> {
    public readonly initialState: IRecipientState = {
        personResponse: null,
    };

    public [RecipientAction.REQUEST_DO_GET_DATA_RECIPIEN_FXN_FINISHED](state: IRecipientState, action: IAction<PersonResponse>): IRecipientState {
        return {
            ...state,
            personResponse: action.payload!,
        };
    }

    public [RecipientAction.SET_EMPTY_DATA_RECIPIENT](state: IRecipientState, action: IAction<PersonResponse>): IRecipientState {
        return {
            ...state,
            personResponse: null,
        };
    }
}
